import React from 'react';
import { assets } from '../../assets/';

import Grid from 'material-ui/Grid';
import Card, { CardHeader } from 'material-ui/Card';

import GoogleMapReact from 'google-map-react';
import { fitBounds } from 'google-map-react/utils';

import { AssetConsumingMarker } from './AssetConsumingMarker';
import { AssetProducingMarker } from './AssetProducingMarker';

import { constants } from '../../constants/index';

const AnyReactComponent = ({ text }) => <div>{text}</div>;

export class MapCard extends React.Component {
  constructor(props) {
    super(props);
    this.onMapLoaded = this.onMapLoaded.bind(this);
    this.setMapBounds = this.setMapBounds.bind(this);
  }

  rad = x => {
    return (x * Math.PI) / 180;
  };

  getDistance = (p1, p2) => {
    var R = 6378137; // Earth’s mean radius in meter
    var dLat = this.rad(p2.lat - p1.lat);
    var dLong = this.rad(p2.lng - p1.lng);
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(this.rad(p1.lat)) *
        Math.cos(this.rad(p2.lat)) *
        Math.sin(dLong / 2) *
        Math.sin(dLong / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c;
    return d; // returns the distance in meter
  };

  setMapBounds(mapContainer, googleMap) {
    const currentAssetConsuming = this.props.currentAssetConsuming;

    const assetsProducing = currentAssetConsuming.producingAssets.map(pA => pA);

    const assetConsumingLat =
      currentAssetConsuming && currentAssetConsuming.gpsLatitude
        ? parseFloat(currentAssetConsuming.gpsLatitude)
        : constants.MapConstants.DEFAULT_ASSET_LATITUDE;
    const assetConsumingLng =
      currentAssetConsuming && currentAssetConsuming.gpsLongitude
        ? parseFloat(currentAssetConsuming.gpsLongitude)
        : constants.MapConstants.DEFAULT_ASSET_LONGITUDE;

    const bounds = new window.google.maps.LatLngBounds();

    bounds.extend(
      new window.google.maps.LatLng(assetConsumingLat, assetConsumingLng)
    );

    if (assetsProducing && assetsProducing.length > 0) {
      assetsProducing.map(asset => {
        bounds.extend(
          new window.google.maps.LatLng(
            parseFloat(asset.gpsLatitude),
            parseFloat(asset.gpsLongitude)
          )
        );

        const polylineStartCoordinates = [
          {
            lat: parseFloat(asset.gpsLatitude),
            lng: parseFloat(asset.gpsLongitude),
          },
          {
            lat: parseFloat(asset.gpsLatitude),
            lng: parseFloat(asset.gpsLongitude),
          },
        ];

        const lineSymbol = {
          path: 'M 0,-1 0,1',
          strokeOpacity: 0.8,
          scale: 2,
        };

        const polylinePath = new window.google.maps.Polyline({
          path: polylineStartCoordinates,
          geodesic: true,
          strokeColor: '#21453C',
          strokeOpacity: 0,
          strokeWeight: 2,
          icons: [
            {
              icon: lineSymbol,
              offset: '0',
              repeat: '10px',
            },
          ],
        });

        var departure = new window.google.maps.LatLng(
          parseFloat(asset.gpsLatitude),
          parseFloat(asset.gpsLongitude)
        ); //Set to whatever lat/lng you need for your departure location
        var arrival = new window.google.maps.LatLng(
          assetConsumingLat,
          assetConsumingLng
        ); //Set to whatever lat/lng you need for your arrival location

        var step = 0;
        var numSteps = 250; //Change this to set animation resolution
        var timePerStep = 5; //Change this to alter animation speed
        var interval = setInterval(function() {
          step += 1;
          if (step > numSteps) {
            step = 0;
          }
          var are_we_there_yet = window.google.maps.geometry.spherical.interpolate(
            departure,
            arrival,
            step / numSteps
          );
          polylinePath.setPath([departure, are_we_there_yet]);
        }, timePerStep);

        polylinePath.setMap(googleMap);
      });
    }

    const newBounds = {
      ne: {
        lat: bounds.getNorthEast().lat(),
        lng: bounds.getNorthEast().lng(),
      },
      sw: {
        lat: bounds.getSouthWest().lat(),
        lng: bounds.getSouthWest().lng(),
      },
    };

    const size = {
      width: mapContainer.clientWidth, // Map container width in pixels
      height: mapContainer.clientHeight, // // Map container height in pixels
    };

    const { center, zoom } = fitBounds(newBounds, size);

    this.props.setMapZoomAndCenter(center, zoom - 1);
  }

  onMapLoaded({ map }) {
    this.setMapBounds(this.mapWrapper, map);
  }

  renderNew() {
    return (
      <div style={{ height: 365, width: '100%' }}>
        <GoogleMapReact
          bootstrapURLKeys={{ key: 'AIzaSyBleDoIxwGmKTDHbxeaMFo-ny5e-xEPoNs' }}
          defaultCenter={this.props.center}
          defaultZoom={this.props.zoom}
        >
          <AnyReactComponent lat={59.955413} lng={30.337844} text="My Marker" />
        </GoogleMapReact>
      </div>
    );
  }

  render() {
    const { classes, zoom, defaultCenter, center } = this.props;
    const assetConsuming = this.props.currentAssetConsuming;
    let houseNumber = assetConsuming.houseNumber;
    let street = assetConsuming.street;
    let zip = assetConsuming.zip;
    let city = assetConsuming.city;
    let region = assetConsuming.region;
    let country = assetConsuming.country;

    if (!assetConsuming || !assetConsuming.producingAssets) return false;

    // Don't filter archived producing assets :
    // they could have been previously used to create certificates
    let cardHeaderTitle = assetConsuming.name
      ? assetConsuming.name
      : assetConsuming.city;
    let cardHeaderSubheader = `${houseNumber} ${street} ${zip} ${city} ${region} ${country}`;

    let markers = [];
    markers.push({ asset: assetConsuming, type: 'consumption' }); //Add the consuming asset

    assetConsuming.producingAssets.map(prodAsset => {
      markers.push({ asset: prodAsset, type: 'production' }); //Add each producing assets
    });

    return (
      <Grid item xs={12} sm={6}>
        <Card className={classes.card} style={{ minHeight: 469 }}>
          <CardHeader
            avatar={
              <img
                src={assets.icons.placeIcon}
                alt="place_icon"
                style={{ maxHeight: 20 }}
              />
            }
            title={cardHeaderTitle}
            subheader={cardHeaderSubheader}
          />
          <div
            style={{ height: 365, width: '100%' }}
            ref={mapWrapper => (this.mapWrapper = mapWrapper)}
          >
            {this.props.currentAssetConsuming._id && (
              <GoogleMapReact
                ref={ref => {
                  this.map = ref;
                }}
                bootstrapURLKeys={{
                  key: 'AIzaSyBleDoIxwGmKTDHbxeaMFo-ny5e-xEPoNs',
                }}
                defaultCenter={defaultCenter}
                defaultZoom={zoom}
                center={center}
                zoom={zoom}
                onGoogleApiLoaded={this.onMapLoaded}
                //yesIWantToUseGoogleMapApiInternals
                //options={getMapOptions}
              >
                {markers.map(marker => {
                  if (marker.type === 'consumption') {
                    //return false
                    return (
                      <AssetConsumingMarker
                        lat={marker.asset.gpsLatitude}
                        lng={marker.asset.gpsLongitude}
                        key={marker.asset._id}
                        consumingAsset={marker.asset}
                      />
                    );
                  }

                  return (
                    <AssetProducingMarker
                      lat={marker.asset.gpsLatitude}
                      lng={marker.asset.gpsLongitude}
                      key={marker.asset._id}
                      producingAsset={marker.asset}
                      history={this.props.history}
                    />
                  );
                })}
              </GoogleMapReact>
            )}
          </div>
        </Card>
      </Grid>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/MapCards/MapCard.js